import { ReactNode, createContext, useEffect, useState } from "react";
import { getCommisionByConsultant } from "../../../../../common/services/commission.api";
import {
  emptyTechnicalConsultant,
  ICommission,
} from "../../../../../types/commission.type";

type InitialStateType = {
  commission: ICommission[];
};

const initialState: InitialStateType = {
  commission: emptyTechnicalConsultant(),
};
// eslint-disable-next-line react-refresh/only-export-components
export const CommissionReportsDashboardContext = createContext(initialState);

type Props = {
  children: ReactNode;
  technicalConsultant: string;
};

export function CommissionReportsDashboardProvider(props: Props) {
  const [commission, setCommission] = useState<ICommission[]>(
    initialState.commission
  );

  useEffect(() => {
    async function loadCommission(technicalConsultant: string) {
      const result = await getCommisionByConsultant(technicalConsultant);
      if (result.ok) {
        setCommission(result.data); // Select the first commission
      }
    }

    loadCommission(props.technicalConsultant);
  }, [props.technicalConsultant]);

  const theState = { commission };

  return (
    <CommissionReportsDashboardContext.Provider
      value={theState as InitialStateType}
    >
      {props.children}
    </CommissionReportsDashboardContext.Provider>
  );
}
